import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/brand/StatusBadge";
import { PriorityBadge } from "@/components/brand/PriorityBadge";
import CompleteActivityDialog from "@/components/activities/CompleteActivityDialog";
import { CheckSquare, Loader2, CheckCircle2, Clock, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const statusTone = (s) => (s === "Completata" ? "success" : s === "Scaduta" ? "danger" : "pending");

export default function ActivitiesPanel({ customerId }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [complete, setComplete] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get(`/customers/${customerId}/activities`); setRows(data); }
    catch (e) { setRows([]); }
  }, [customerId]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="activities-panel">
      <h3 className="ds-section-title flex items-center gap-2"><CheckSquare className="h-4 w-4 text-brand" /> Attività & Follow-up</h3>
      {rows === null ? <div className="py-10 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-brand" /></div>
        : rows.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-2 py-12 text-center text-slate-500">
            <CheckSquare className="h-8 w-8 text-slate-300" /><div className="font-display font-semibold text-slate-700">Nessuna attività</div>
            <p className="max-w-sm text-sm">Le attività di follow-up compaiono automaticamente quando invii un preventivo.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {rows.map((a) => (
              <div key={a.id} className="ds-card flex flex-wrap items-center justify-between gap-3 p-3" data-testid={`cust-activity-${a.id}`}>
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-brand/10 px-2 py-0.5 text-xs font-semibold text-brand">{a.type}</span>
                    <StatusBadge type={statusTone(a.status)}>{a.status}</StatusBadge>
                    <PriorityBadge level={a.priority} />
                    <span className="inline-flex items-center gap-1 text-xs text-slate-500"><Clock className="h-3 w-3" /> {new Date(a.activity_date).toLocaleDateString("it-IT")}</span>
                  </div>
                  {(a.notes || a.quote_number) && <div className="mt-0.5 text-xs text-slate-500">{a.quote_number ? `Preventivo ${a.quote_number} · ` : ""}{a.notes}</div>}
                </div>
                <div className="flex gap-1">
                  <Button size="sm" variant="ghost" onClick={() => navigate(`/whatsapp?customer=${customerId}&template=${encodeURIComponent("Follow-up preventivo")}${a.quote_id ? `&quote=${a.quote_id}` : ""}`)} title="Follow-up via WhatsApp" data-testid={`cust-activity-wa-${a.id}`}><MessageCircle className="h-4 w-4 text-success" /></Button>
                  {a.status !== "Completata" && <Button size="sm" variant="ghost" onClick={() => setComplete(a)} data-testid={`cust-activity-complete-${a.id}`}><CheckCircle2 className="h-4 w-4" /></Button>}
                </div>
              </div>
            ))}
          </div>
        )}
      {complete && <CompleteActivityDialog open={!!complete} onOpenChange={(v) => !v && setComplete(null)} activity={complete} onSaved={() => { setComplete(null); load(); }} />}
    </div>
  );
}
